import { render, staticRenderFns } from "./SettingsPlane.vue?vue&type=template&id=342753fa&scoped=true&lang=pug"
import script from "./SettingsPlane.vue?vue&type=script&lang=js"
export * from "./SettingsPlane.vue?vue&type=script&lang=js"
import style0 from "./SettingsPlane.vue?vue&type=style&index=0&id=342753fa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342753fa",
  null
  
)

export default component.exports